import MeetingOptInView from './MeetingOptInView';

export default MeetingOptInView;